export default {
  needLogin: true,
  rewriteRoute: {
    path: '/promocao/vip/history',
    name: 'vipHistory',
  }
}
